import Immutable from 'immutable';
import {
  FLAG_GETTING_FUEL_PROFILES,
  GET_FUEL_PROFILES,
  CLEAR_FUEL_PROFILES,
  FLAG_FUEL_PROFILE_ACTIVITY,
  CLEAR_FUEL_PROFILE,
  GET_FUEL_PROFILE,
} from '../../../actions/types/traffic';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_FUEL_PROFILES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_FUEL_PROFILES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_FUEL_PROFILES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_FUEL_PROFILE_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_FUEL_PROFILE:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_FUEL_PROFILE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
